// extracted by mini-css-extract-plugin
module.exports = {"frame":"excursions_frame__r0xHT"};